import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

type Props = {
  open: boolean;
  onClose: () => void;
  mode: 'afterAdd' | 'afterRemove';
  email?: string;
};

const bodySx = { lineHeight: 1.7 } as const;

/**
 * 職員追加・削除後に Google Cloud Console（OAuth テストユーザー等）の手作業確認を促す
 */
const GoogleConsoleStaffDialog: React.FC<Props> = ({ open, onClose, mode, email }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          m: 2,
        },
      }}
    >
      <DialogTitle sx={{ pt: 3, px: 3, pb: 1, typography: 'h6' }}>Google Cloud Console の確認</DialogTitle>
      <DialogContent sx={{ px: 3, pt: 1, pb: 2 }}>
        {mode === 'afterAdd' ? (
          <Stack spacing={1.5}>
            <Typography variant="body2" color="text.secondary" sx={bodySx}>
              Google Cloud Console の OAuth クライアント設定（テストユーザーへの追加や公開ステータス）に、この職員の
              Google アカウントを反映しましたか？
            </Typography>
            {email ? (
              <Typography variant="body2" color="text.secondary" sx={bodySx}>
                <strong>メール:</strong> {email}
              </Typography>
            ) : null}
          </Stack>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={bodySx}>
            職員を OAuth のテストユーザーから外すなど、Google Cloud Console 側の設定変更が必要な場合があります。反映済みか確認してください。
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1.5, flexWrap: 'wrap' }}>
        <Button onClick={onClose} variant="contained" sx={{ minWidth: 100 }}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GoogleConsoleStaffDialog;
